/**
 * The URL Picture My Heritage owns.
 *
 * Deliberately free of imports: both the router and globalChromeRoutes need to name this route,
 * and globalChromeRoutes is a small synchronous helper that should not pull a React component tree
 * in behind it.
 */
export const PMH2_ROUTE_PATH = '/picturemyheritage'
